// extracted by mini-css-extract-plugin
export default {"image":"Picture_image__bFn00","small":"Picture_small__R2HPW","round":"Picture_round__QRiCH","medium":"Picture_medium__AcIpS","large":"Picture_large__Ws00V"};